(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-announcement"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mp-announcement')) {
  customElements.define('mp-announcement', class extends HTMLElement {
    connectedCallback() {
      this.msgs = Array.from(this.querySelectorAll('.mp-ann__msg'));
      if (this.msgs.length < 2) return;
      this.i = 0;
      this.timer = setInterval(() => {
        this.msgs[this.i].classList.remove('is-active');
        this.i = (this.i + 1) % this.msgs.length;
        this.msgs[this.i].classList.add('is-active');
      }, 4500);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mp-hero-slider')) {
  customElements.define('mp-hero-slider', class extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.mp-hero__slide'));
      this.dots = Array.from(this.querySelectorAll('.mp-hero__dot'));
      this.index = 0;
      this.interval = parseInt(this.dataset.interval || '0', 10);
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => { this.go(i); this.start(); }));
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      let startX = null;
      this.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; this.stop(); }, { passive: true });
      this.addEventListener('touchend', (e) => {
        if (startX === null) return;
        const dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) this.go(this.index + (dx < 0 ? 1 : -1));
        startX = null;
        this.start();
      }, { passive: true });
      this.onBlockSelect = (e) => {
        const i = this.slides.findIndex((s) => s.dataset.blockId === e.detail.blockId);
        if (i > -1) { this.stop(); this.go(i); }
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      this.go(0);
      this.start();
    }
    disconnectedCallback() {
      this.stop();
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }
    go(i) {
      const n = this.slides.length;
      if (!n) return;
      this.index = (i + n) % n;
      this.slides.forEach((slide, k) => {
        const active = k === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.querySelectorAll('a').forEach((a) => { a.tabIndex = active ? 0 : -1; });
      });
      this.dots.forEach((dot, k) => dot.setAttribute('aria-current', k === this.index ? 'true' : 'false'));
    }
    start() {
      this.stop();
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.interval > 0 && this.slides.length > 1 && !reduce) {
        this.timer = setInterval(() => this.go(this.index + 1), this.interval);
      }
    }
    stop() { clearInterval(this.timer); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
